module.exports = __webpack_public_path__ + "img/location-empty.82991548.svg";